module.exports = __webpack_public_path__ + "static/vanifer-10a189305ef9a4b45373fd412064a6c4.jpeg";